import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WifiTetheringErrorRoundedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wifi_tethering_error_rounded"}/>
}
